module.exports = __webpack_public_path__ + "img/ednextlogo-ob6fofxcwq4u0n7q4bm43a6k0jqcqn0c178ztg9kls.577162cb.jpeg";